'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable */


var BinaryChart = function (_Component) {
  _inherits(BinaryChart, _Component);

  function BinaryChart(props) {
    _classCallCheck(this, BinaryChart);

    var _this = _possibleConstructorReturn(this, (BinaryChart.__proto__ || Object.getPrototypeOf(BinaryChart)).call(this, props));

    _this.styles = require('./BinaryChart.scss');
    _this.state = {
      legend: '',
      width: 0,
      height: 0
    };

    _this._chart = null;
    _this.Chart = require('chart.js');

    _this.Chart.plugins.register({
      afterDraw: function afterDraw(chartInstance) {
        if (chartInstance.config.options.showDatapoints) {
          var helpers = _this.Chart.helpers;
          var ctx = chartInstance.chart.ctx;
          var fontColor = helpers.getValueOrDefault(chartInstance.config.options.showDatapoints.fontColor, chartInstance.config.options.defaultFontColor);

          // render the value of the chart above the bar
          ctx.font = _this.Chart.helpers.fontString(_this.Chart.defaults.global.defaultFontSize, 'normal', _this.Chart.defaults.global.defaultFontFamily);
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';
          ctx.fillStyle = fontColor;

          var xLargeVariable = chartInstance.config.options.xLargeVariable !== undefined ? chartInstance.config.options.xLargeVariable : 0;
          var yLargeVariable = chartInstance.config.options.yLargeVariable !== undefined ? chartInstance.config.options.yLargeVariable : 12;
          var xSmallVariable = chartInstance.config.options.xSmallVariable !== undefined ? chartInstance.config.options.xSmallVariable : 20;
          var ySmallVariable = chartInstance.config.options.ySmallVariable !== undefined ? chartInstance.config.options.ySmallVariable : 12;
          chartInstance.data.datasets.forEach(function (dataset) {
            // find scale
            var max = dataset.data.reduce(function (numb1, numb2) {
              return Math.max(numb1, numb2);
            });
            var min = dataset.data.reduce(function (numb1, numb2) {
              return Math.min(numb1, numb2);
            });

            for (var count = 0; count < dataset.data.length; count++) {
              var model = dataset._meta[Object.keys(dataset._meta)[0]].data[count]._model;
              var scaleMax = dataset._meta[Object.keys(dataset._meta)[0]].data[count]._yScale.maxHeight;
              var xPos = model.x;
              var yPos = (scaleMax - model.y) / scaleMax >= 0.93 ? model.y + 20 : model.y - 5;
              if (max - min > 70 && max === dataset.data[count] || dataset.data[count] !== 0 && min === 0) {
                xPos = xPos + xLargeVariable;
                yPos = yPos + yLargeVariable;
              } else {
                xPos = xPos + xSmallVariable;
                yPos = yPos + ySmallVariable;
              }
              ctx.fillStyle = fontColor;
              ctx.fillText(dataset.data[count], xPos, yPos);
            }
          });
        }
        if (chartInstance.options.centertext && chartInstance.options.centertext.name && chartInstance.options.centertext.afterdraw) {
          _this.drawCenterText(chartInstance);
        }
        if (chartInstance.options.lefttext && chartInstance.options.lefttext.name && chartInstance.options.lefttext.afterdraw) {
          _this.drawLeftText(chartInstance);
        }
        if (chartInstance.options.righttext && chartInstance.options.righttext.name && chartInstance.options.righttext.afterdraw) {
          _this.drawRightText(chartInstance);
        }
      },
      beforeDraw: function beforeDraw(chartInstance) {
        if (chartInstance.options.centertext && chartInstance.options.centertext.name && chartInstance.options.centertext.beforedraw) {
          _this.drawCenterText(chartInstance);
        }
        if (chartInstance.options.lefttext && chartInstance.options.lefttext.name && chartInstance.options.lefttext.beforedraw) {
          _this.drawLeftText(chartInstance);
        }
        if (chartInstance.options.righttext && chartInstance.options.righttext.name && chartInstance.options.righttext.beforedraw) {
          _this.drawRightText(chartInstance);
        }
      }
    });
    return _this;
  }

  _createClass(BinaryChart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.width === 0 && this.state.height === 0) {
        this.initChart();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (this.state.width === 0 && this.state.height === 0) {
        this.initChart();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateChart();
    }
  }, {
    key: 'drawCenterText',
    value: function drawCenterText(chartInstance) {
      var width = chartInstance.chart.width;
      var height = chartInstance.chart.height;
      var ctx = chartInstance.chart.ctx;

      ctx.font = (chartInstance.options.centertext.fontSize ? chartInstance.options.centertext.fontSize + 'px' : (height / 70).toFixed(2) + 'em') + ' sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = chartInstance.options.centertext.fontColor ? chartInstance.options.centertext.fontColor : '#000000';

      var text = chartInstance.options.centertext.name;
      var textX = Math.round((width - ctx.measureText(text).width) / 2);
      var textY = height / 4;
      ctx.fillText(text, textX, textY);
      if (chartInstance.options.centertext.subtext && chartInstance.options.centertext.subtext.name) {
        var ctx1 = chartInstance.chart.ctx;
        ctx1.font = (chartInstance.options.centertext.subtext.fontWeight ? chartInstance.options.centertext.subtext.fontWeight : 'lighter') + ' ' + (chartInstance.options.centertext.subtext.fontSize ? chartInstance.options.centertext.subtext.fontSize + 'px' : (height / 140).toFixed(2) + 'em') + ' sans-serif';
        ctx1.textBaseline = 'middle';
        ctx1.fillStyle = chartInstance.options.centertext.subtext.fontColor ? chartInstance.options.centertext.subtext.fontColor : '#000000';
        var subText = chartInstance.options.centertext.subtext.name;
        var subTextX = Math.round((width - ctx.measureText(subText).width) / 2);
        var subTextY = height / 2 + 20;
        ctx1.fillText(subText, subTextX, subTextY);
      }
    }
  }, {
    key: 'drawLeftText',
    value: function drawLeftText(chartInstance) {
      var height = chartInstance.chart.height;
      var ctx = chartInstance.chart.ctx;

      ctx.font = (chartInstance.options.lefttext.fontWeight ? chartInstance.options.lefttext.fontWeight : 'lighter') + ' ' + chartInstance.options.lefttext.fontSize + ' sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = chartInstance.options.lefttext.fontColor ? chartInstance.options.lefttext.fontColor : '#000000';

      var text = chartInstance.options.lefttext.name;
      var textX = 5;
      var textY = height / 4;
      ctx.fillText(text, textX, textY);
    }
  }, {
    key: 'drawRightText',
    value: function drawRightText(chartInstance) {
      var width = chartInstance.chart.width;
      var height = chartInstance.chart.height;
      var ctx = chartInstance.chart.ctx;

      ctx.font = (chartInstance.options.righttext.fontWeight ? chartInstance.options.righttext.fontWeight : 'lighter') + ' ' + chartInstance.options.righttext.fontSize + ' sans-serif';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = chartInstance.options.righttext.fontColor ? chartInstance.options.righttext.fontColor : '#000000';

      var text = chartInstance.options.righttext.name;
      var textX = Math.round(width - ctx.measureText(text).width) - 5;
      var textY = height / 4;
      ctx.fillText(text, textX, textY);
    }
  }, {
    key: 'initChart',
    value: function initChart() {
      var wrapper = _reactDom2.default.findDOMNode(this.refs.chartWrapper);
      var width = wrapper.clientWidth;
      var height = wrapper.clientHeight;
      if (this._chart && this.props.responsive) {
        this._chart.chart.width = width;
        this._chart.chart.height = height;
      }
      this.state.width = width === 0 ? 100 : width;
      this.state.height = height === 0 ? 100 : height;
      this.setState({ width: width, height: height });
    }
  }, {
    key: 'updateChart',
    value: function updateChart() {
      var _props = this.props,
          type = _props.type,
          data = _props.data,
          options = _props.options,
          legendTemplate = _props.legendTemplate;

      if (this._chart) {
        this._chart.destroy();
      }
      var ctx = this.refs.canvas.getContext('2d');
      this._chart = new this.Chart(ctx, {
        type: type,
        data: data,
        options: options,
        legendTemplate: legendTemplate
      });
      this.state.legend = this._chart.generateLegend();
    }
  }, {
    key: 'handleChartClick',
    value: function handleChartClick() {
      if (this.props.handleClick !== undefined) {
        this.props.handleClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var wrapperStyle = this.props.wrapperStyle;

      var width = this.props.width ? this.props.width : this.state.width;
      var height = this.props.height ? this.props.height : this.state.height;

      return _react2.default.createElement(
        'div',
        {
          style: wrapperStyle,
          className: this.styles.chart_wrapper,
          ref: 'chartWrapper',
          onClick: this.handleChartClick.bind(this)
        },
        _react2.default.createElement('canvas', { ref: 'canvas', width: width, height: height })
      );
    }
  }]);

  return BinaryChart;
}(_react.Component);

BinaryChart.propTypes = {
  type: _propTypes2.default.string.isRequired,
  legendTemplate: _propTypes2.default.string,
  data: _propTypes2.default.object,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  options: _propTypes2.default.object,
  responsive: _propTypes2.default.bool,
  wrapperStyle: _propTypes2.default.object,
  handleClick: _propTypes2.default.func,
  customChart: _propTypes2.default.string
};
exports.default = BinaryChart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinaryChart/BinaryChart.js
// module id = 2141
// module chunks = 1